<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="入稿ファイルをアップロード" />
    </v-flex>
    <v-flex xs12 mt-3 offset-xs1>
      <p>
        市区町村などの行政区画へ配信エリアをご指定される場合、行政区画エリア指定用フォーマットをダウンロードしてご指定下さい。
      </p>
    </v-flex>
    <v-flex xs5 mt-1 offset-xs1>
      <AppForm label="行政区画指定用フォーマット" />
    </v-flex>
    <v-flex xs1 mt-4>
      <a :href="uri" :download="filenName">
        <v-icon>save_alt</v-icon>
      </a>
    </v-flex>
    <v-flex xs12 mt-3 offset-xs1>
      <AppFileDropArea
        :mime-types="mimeTypes"
        @files="onDropFile"
        class="file-wrapper"
      >
        <v-layout class="dropArea pa-2 mb-1 justify-center align-center">
          ここに入稿用ファイルをドラッグ
        </v-layout>
        <template v-slot:drag>
          <v-layout
            class="dropArea dragging pa-2 mb-1 justify-center align-center"
          >
            ドロップして入稿用ファイルの内容を読み込む
          </v-layout>
        </template>
      </AppFileDropArea>
    </v-flex>
    <v-flex v-if="uploadFile.fileName" xs10 mt-3 offset-xs1>
      <AppForm label="ファイル名" />
    </v-flex>
    <v-flex v-if="uploadFile.fileName" xs10 offset-xs2>
      <AppForm :label="uploadFile.fileName" />
    </v-flex>
    <v-flex xs12 mt-3 offset-xs1>
      <p>
        ※ 複数のファイルを読み込む場合はzipファイルにして読み込んで下さい。<br />
        shapeファイルでエリア指定を行う場合、shapeファイルのファイル名がグループ名として登録されます。
      </p>
    </v-flex>
    <v-flex xs12 mt-2 offset-xs1>
      <p class="red-txt">
        1キャンペーンあたりにご指定可能な市区町村数、登録可能なshapeファイル数はいずれも最大99です。
      </p>
    </v-flex>
    <v-flex xs12>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import { mimeTypes } from '@/components/App/AppFileDropArea'

export default {
  name: 'CampaignModalPageCustomGeo',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      uri: '/files/all-menu/行政区画指定用フォーマット.xlsx',
      filenName: '行政区画指定用フォーマット.xlsx',
    }
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    uploadFile() {
      return this.form.campaign.menuSetting.uploadFile
    },
    errorMessage() {
      if (!this.form.campaign.menuSetting.isNew) return ''
      if (this.uploadFile.fileName === '' && this.menuSetting.memo === '') {
        return '入稿情報が登録されていません。\n入稿ファイルのアップロードもしくは、備考欄へ入稿情報を記載して下さい。'
      }
      return ''
    },
    mimeTypes() {
      return Object.values(mimeTypes.csv)
        .concat(Object.values(mimeTypes.document))
        .concat(Object.values(mimeTypes.multiple))
    },
  },
  methods: {
    onDropFile(files) {
      const [file] = files
      this.uploadFile.file = file
      this.uploadFile.fileName = file.name
    },
  },
}
</script>

<style scoped>
.red-txt {
  color: red;
}

.file-wrapper {
  border: 1px dotted #666;
  height: 100px;
  transition: height 0.5s linear;
}

.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
